import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import type { QueryConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type MyTenantsQueryOptions = {
  queryConfig?: QueryConfig<typeof getMyTenantsQueryOptions>;
};

export const getMyTenants = () => {
  return extractData(api.users.tenant.get());
};

export const getMyTenantsQueryOptions = () => {
  return queryOptions({
    queryKey: ['tenant', 'me'],
    queryFn: getMyTenants,
  });
};

export const useMyTenants = ({ queryConfig }: MyTenantsQueryOptions = {}) => {
  return useSuspenseQuery({ ...getMyTenantsQueryOptions(), ...queryConfig });
};
